import { BaseContainerModel } from '../base-container.model';

export class FpxBankListModel extends BaseContainerModel {
  bankId: string;
  bankName: string;
  displayName: string;
  status: string; //bankStatus (A:active, B:blocked)
}
